export default __webpack_public_path__ + "static/media/revealed2.5aef2dd2.png";